
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/game', icon: 'ri-gamepad-line', label: 'Jugar' },
    { path: '/vote', icon: 'ri-heart-line', label: 'Votar' },
    { path: '/ranking', icon: 'ri-trophy-line', label: 'Ranking' },
    { path: '/leagues', icon: 'ri-team-line', label: 'Ligas' },
    { path: '/profile', icon: 'ri-user-line', label: 'Perfil' }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-0 py-2 z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center justify-center space-y-1 transition-colors duration-200 ${
              location.pathname === item.path 
                ? 'text-indigo-600' 
                : 'text-gray-500 hover:text-indigo-500'
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`${item.icon} text-xl`}></i>
            </div>
            <span className="text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
